import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { MatIcon } from '@angular/material/icon';
import { ActivityEntryComponent } from './activity-entry.component';
import { SectionTitleComponent } from '../../../components/section-title/section-title.component';
import { ActivityItem } from '../../models/dashboard.model';

@Component({
  selector: 'app-activity-feed',
  imports: [TranslatePipe, MatIcon, ActivityEntryComponent, SectionTitleComponent],
  templateUrl: './activity-feed.component.html',
  styleUrl: './activity-feed.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActivityFeedComponent {
  activity = input.required<ActivityItem[]>();

  protected readonly headingId = 'activity-feed-heading';
}
